import { useBulkActionsState } from './useBulkActionsState';
export const useBulkActionsSelectionState = () => {
  const state = useBulkActionsState();
  return state.selection;
};